import { render, staticRenderFns } from "./DesignLibrarySidebar.vue?vue&type=template&id=48ec2154&"
import script from "./DesignLibrarySidebar.vue?vue&type=script&lang=ts&"
export * from "./DesignLibrarySidebar.vue?vue&type=script&lang=ts&"
import style0 from "./DesignLibrarySidebar.vue?vue&type=style&index=0&id=48ec2154&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports